import React from "react";
import pdfUrl from '../home/Final Schedule VETOMAC 2023.pdf';
import LoP from '../home/List of registered participants.pdf';

function Summary() {

    const downloadProgramSummary = () => {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "VETOMAC 2023 Program Summary.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const downloadList = () => {
        const link = document.createElement("a");
        link.href = LoP;
        link.download = "VETOMAC 2023 List of registered participants.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <div className="scope">
            <h2 className="compTitle">Conference Summary</h2>
            <div className="heroButtons" style={{justifyContent: 'center'}}>
                <a onClick={downloadProgramSummary} className="download">Download Final Program Summary (updated 15th Dec, 2023)</a>
                {/* <a onClick={downloadList} className="download">Download List of Registered Participants</a> */}
            </div>
        </div>
    )
}

export default Summary;